import { NotificationsActive, ThumbUpAlt } from "@mui/icons-material";
import CallIcon from "@mui/icons-material/Call";
import { Box, Button, MenuItem, Stack, Typography } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import { deepOrange, deepPurple } from "@mui/material/colors";
import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { StandardCard } from "../../../components/Cards";
import { PageContainer } from "../../../components/container/PageContainer";
import { CustomChip } from "../../../components/CustomChip";
import { CustomLink } from "../../../components/CustomLink/CustomLink";
import { CustomSelect } from "../../../components/formsComponents";
import { CustomDatePicker } from "../../../components/formsComponents/CustomDatePicker";
import { IconicMultiColumnCard } from "../../../components/iconicMultiColumnCard/IconicMultiColumnCard";
import { EmailComposeRightPanel } from "../../../components/MessagesDialogs/EmailCompose/EmailCompose";
import { MessagesDialogWrapper } from "../../../components/MessagesDialogs/MessagesDialogWrapper/MessagesDialogWrapper";
import { SmsDialog } from "../../../components/MessagesDialogs/SmsDialog/SmsDialog";
import { WhatsAppDialog } from "../../../components/MessagesDialogs/WhatsAppDialog/WhatsAppDialog";
import { StandardTableActions } from "../../../components/StandardTableActions/StandardTableActions";
import { DateFilterDropdown } from "../../../components/Table/components/DateFilterDropdown/DateFilterDropdown";
import { DataTable } from "../../../components/Table/DataTable";
import { useDateFilter } from "../../../components/Table/hooks/useDateFilter";
import {
  IDataTableProps,
  MobileLogoRenderType,
  RenderType,
} from "../../../components/Table/interfaces/IDataTableProps";
import {
  CSVExportPlugin,
  RefreshPlugin,
  SearchPlugin,
} from "../../../components/Table/plugins";
import { LoadState } from "../../../constants/enums";
import { capitalizeWords, renderDropdownValue } from "../../../helpers";
import { useDispatchWrapper, useRecordCounts } from "../../../hooks";
import { Breadcrumb } from "../../../layout/fullLayout/breadcrumb/Breadcrumb";
import { IBreadcrumbProps } from "../../../layout/fullLayout/breadcrumb/IBreadcrumbProps";
import {
  clearRecordCounts,
  fetchRecordCountsAsync,
} from "../../../redux/common/commonActions";
import { IStoreState } from "../../../redux/initialStoreState";
import { IUserProfile } from "../../../redux/UserProfileList/userProfile.types";
import {
  fetchUsersListAsync,
  upsertUserAysnc,
} from "../../../redux/UserProfileList/userProfileActions";
import { AddNewUserDialog } from "./AddNewUser";
import { BeforeProfileTypes } from "./UsersList.types";

export const BeforeProfile: React.FC = () => {
  const BCrumb: IBreadcrumbProps["items"] = [
    {
      to: "/dashbaord",
      title: "dashboard",
    },
    {
      title: "users",
    },
  ];

  const { data, totalNumberOfRecords, loading } = useSelector(
    (storeState: IStoreState) => storeState.userprofile.users
  );
  const [openCreateUser, setOpenCreateUser] = React.useState(false);

  const [tablePagination, setTablePagination] = React.useState({
    pageNumber: 1,
    rowsInPerPage: 50,
  });
  const [selectedOpp, setSelectedOppr] = React.useState<{
    isAllSelected: boolean;
    leads: BeforeProfileTypes[];
  }>({
    isAllSelected: false,
    leads: [],
  });
  const [status, setStatus] = React.useState<
    BeforeProfileTypes["status"] | "-1"
  >("ACTIVE");

  const { date, type, handleDateSelectChange, dateDropdownList, setDate } =
    useDateFilter({ defaultType: "last28Days" });

  const [file, setFile] = React.useState<File | null>(null);
  const dispatch = useDispatchWrapper();
  const navigate = useNavigate();

  const [searchType, setSearchType] = React.useState<string[]>(["first_name"]);
  const [search, setSearch] = React.useState<string>("");

  const fetchList = async () => {
    dispatch(
      fetchUsersListAsync(
        tablePagination.pageNumber,
        tablePagination.rowsInPerPage,
        status,
        date,
        search,
        searchType
      )
    );
  };

  React.useEffect(() => {
    fetchList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tablePagination, date, search, searchType]);

  const menuItems =
    selectedOpp.leads.length > 0 || selectedOpp.isAllSelected
      ? [
          {
            key: "action",
            onRender: () => (
              <CustomSelect
                sx={{ minWidth: "120px" }}
                value={""}
                displayEmpty
                renderValue={renderDropdownValue(`Choose Bulk Action`)}
                //onChange={(e) => setBranchOffice(e.target.value as string)}
              >
                <MenuItem value="1">Email</MenuItem>
              </CustomSelect>
            ),
          },
        ]
      : [];

  const handleActiveInactiveItem = (data: IUserProfile) => {
    dispatch(
      upsertUserAysnc(data, file, (isSuccess) => {
        if (isSuccess) {
          fetchList();
        }
        // setSaveLoading(false);
      })
    );
  };

  const usersTableProps: IDataTableProps = {
    isPagination: true,
    totalRecords: totalNumberOfRecords,
    rowsPerPageOptions: tablePagination.rowsInPerPage,
    isDataLoading: loading === LoadState.InProgress,
    selectionMode: "multiple",
    uniqueRowKeyName: "id",
    tableCommandBarProps: {
      leftItems: {
        customPlugins: [
          ...menuItems,
          {
            key: "status",
            onRender: () => (
              <CustomSelect
                sx={{ minWidth: "120px" }}
                value={status}
                onChange={(e) => setStatus(e.target.value as "ACTIVE")}
              >
                <MenuItem value="-1">All Status</MenuItem>
                <MenuItem value="ACTIVE">Active</MenuItem>
                <MenuItem value="INACTIVE">Inactive</MenuItem>
              </CustomSelect>
            ),
          },
          {
            key: "byDate",
            onRender: () => (
              <DateFilterDropdown
                value={type}
                options={dateDropdownList}
                onChange={handleDateSelectChange}
              />
            ),
          },
          {
            key: "fromDate",
            onRender: () =>
              type === "custom" ? (
                <CustomDatePicker
                  sx={{ minWidth: "150px" }}
                  value={date.fromDate}
                  onChange={(newValue) => {
                    const newDate = moment(newValue).format("YYYY-MM-DD");
                    setDate({ ...date, fromDate: newDate });
                  }}
                />
              ) : (
                <></>
              ),
          },
          {
            key: "toDate",
            onRender: () =>
              type === "custom" ? (
                <CustomDatePicker
                  sx={{ minWidth: "150px" }}
                  value={date.toDate}
                  onChange={(newValue) => {
                    const newDate = moment(newValue).format("YYYY-MM-DD");
                    setDate({ ...date, toDate: newDate });
                  }}
                />
              ) : (
                <></>
              ),
          },
          {
            key: "csvExport",
            onRender: (columns, items) => (
              <CSVExportPlugin
                columns={columns}
                items={items}
                filePrefixName="Report"
              />
            ),
          },
          {
            key: "refresh",
            onRender: () => <RefreshPlugin onClick={fetchList} />,
          },
        ],
      },
      rightItems: {
        plugins: {
          // searchField: {
          //   searchKeys: [],
          //   items: data,
          // },
        },
        customPlugins: [
          {
            key: "search",
            onRender: () => {
              return (
                <SearchPlugin
                  selectedDropdownValue={searchType}
                  dropdownOptions={[
                    // { label: "Username", value: "username" },
                  
                    { label: "Name", value: "full_name" },
                    { label: "Email", value: "personal_email" },
                    { label: "Role", value: "role_value" },
                    { label: "Mobile", value: "mobile" },
                    { label: "Branch", value: "branch" },
                  ]}
                  onDropdownChange={(value) => setSearchType(value)}
                  onChange={(newValue) => {
                    setSearch(newValue);
                  }}
                />
              );
            },
          },
        ],
      },
    },
    mobileLogo: {
      type: MobileLogoRenderType.reactNode,
      onMobileLogoRender: (data: any) => {
        return (
          <Avatar
            sx={{
              width: 45,
              height: 45,
              color: "#fff",
              ml: "-8px",
              mr: 2,
            }}
          ></Avatar>
        );
      },
    },
    columns: [
      {
        key: "view",
        headerName: "Actions",
        fieldName: "",
        renderType: RenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row) => {
          return (
            <StandardTableActions
              onDeleteClick={() => {
                handleActiveInactiveItem({ ...row, status: "INACTIVE" });
              }}
              onReactiveClick={() => {
                handleActiveInactiveItem({ ...row, status: "ACTIVE" });
              }}
              onEditClick={() => {
                navigate("/users/manage/" + row.user_uuid);
              }}
            />
          );
        },
      },
      {
        key: "first_name",
        headerName: "Name",
        fieldName: "first_name",
        exportCellWidth: 25,
        renderType: RenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row: IUserProfile) => {
          return (
            <Stack direction="row" alignItems={"center"} spacing={1}>
              {value.value && (
                <>
                  <Avatar
                    sx={{
                      bgcolor:
                        value.column.rowIndex % 2 === 0
                          ? deepOrange[400]
                          : deepPurple[400],
                    }}
                  >
                    {value.value.substring(0, 1)}
                  </Avatar>
                  <CustomLink
                    to={"/users/manage/" + row.user_fact_id}
                    // /users/manage/" + row.user_fact_id
                    label={row.first_name + " " + row.last_name}
                  />
                </>
              )}
            </Stack>
          );
        },
      },
      {
        key: "email",
        headerName: "Email",
        fieldName: "email",
        renderType: RenderType.CUSTOM_RENDER,
        exportCellWidth: 30,
        enableSorting: true,
        onRowCellRender: (value, row) => {
          return (
            <EmailComposeRightPanel
              displayLabel={row.email}
              toEmail={row.email}
            />
          );
        },
      },
     
      {
        key: "mobile",
        headerName: "Mobile",
        fieldName: "mobile",
        exportCellWidth: 25,
        renderType: RenderType.TEXT_DARK,
        onRowCellRender: (value, row: IUserProfile) => {
          if (row.mobile) {
            return (
              <MessagesDialogWrapper>
                <CallIcon color="primary" fontSize="small" />

                <WhatsAppDialog mobileNumber={row.mobile} />
                <SmsDialog mobileNumber={row.mobile} />
                <Typography variant="body1">{row.mobile}</Typography>
              </MessagesDialogWrapper>
            );
          }

          return "--";
        },
      },
    

      {
        key: "status",
        headerName: "Status",
        fieldName: "status",
        enableSorting: true,
        renderType: RenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row: IUserProfile) => {
          if (row.status === "ACTIVE") {
            return (
              <CustomChip
                color="success"
                icon={<ThumbUpAlt />}
                content={"Active"}
                size="small"
              />
            );
          } else {
            return (
              <CustomChip
                color="error"
                icon={<NotificationsActive />}
                content={"Deactive"}
                size="small"
              />
            );
          }
        },
      },

      // {
      //   key: "view",
      //   headerName: "Actions",
      //   fieldName: "",
      //   renderType: RenderType.CUSTOM_RENDER,
      //   onRowCellRender: (value, row) => {
      //     return (
      //       <StandardTableActions
      //         onViewClick={() => { }}
      //         onEditClick={() => {
      //           navigate("/users/manage/" + row.user_fact_id);
      //         }}
      //       />
      //     );
      //   },
      // },
    ],
    items: data,
    onPageChange: (newPageNumber: number) => {
      setTablePagination({ ...tablePagination, pageNumber: newPageNumber });
    },
    onRowsPerPageChange: (pageNumber: number, rowsPerPage: number) => {
      setTablePagination({
        pageNumber: pageNumber,
        rowsInPerPage: rowsPerPage,
      });
    },
    onSelection: (isAllSelected: boolean, rows: BeforeProfileTypes[]) => {
      setSelectedOppr({ isAllSelected: isAllSelected, leads: rows });
    },
  };

  const handleToggleCreate = () => {
    setOpenCreateUser(!openCreateUser);
    // navigate("/users/manage");
  };

  const { list: recordsCounts, loading: recordCountsLoading } =
    useRecordCounts();

  React.useEffect(() => {
    dispatch(
      fetchRecordCountsAsync(
        "latest_user",

        date.fromDate,
        date.toDate
      )
    );
    return () => {
      dispatch(clearRecordCounts());
    };
  }, [date.fromDate, date.toDate]);

  return (
    <PageContainer title="before Profile" description="this is before profile">
      <Breadcrumb title="" items={BCrumb} />

      <IconicMultiColumnCard
        columns={recordsCounts.map((item) => {
          return {
            heading: capitalizeWords(item.status),
            value: item.count,
            colSize: 2,
          };
        })}
      />

      <StandardCard>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          sx={{
            mx: 5,
            my: 2,
          }}
        >
          <Typography variant="h2" fontWeight={"700"}>
            Users
          </Typography>
          <Button variant="contained" onClick={handleToggleCreate}>
            Add User
          </Button>
        </Box>

        <DataTable {...usersTableProps} />
      </StandardCard>
      {openCreateUser && (
        <AddNewUserDialog open={openCreateUser} onClose={handleToggleCreate} />
      )}
    </PageContainer>
  );
};
